import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumbs";
import UserCheckInTable from "./UserCheckInTable";

export default function CheckIn() {
  return (  
    <div>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Control Room" breadcrumbItem="Guard Check-Ins" />
          <UserCheckInTable />
        </Container>
      </div>
    </div>
  );
}
